import { useState, useCallback } from 'react';
import { CaptionCornerModel, fetchCaptionCornerModels } from '../services/api';

interface UseFileListReturn {
  files: CaptionCornerModel[];
  totalFiles: number;
  loading: boolean;
  error: string | null;
  refreshFiles: () => Promise<void>;
}

export const useFileList = (): UseFileListReturn => {
  const [files, setFiles] = useState<CaptionCornerModel[]>([]);
  const [totalFiles, setTotalFiles] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refreshFiles = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const fetchedFiles = await fetchCaptionCornerModels();
      setFiles(fetchedFiles);
      setTotalFiles(fetchedFiles.length);
    } catch (err) {
      setError('Failed to fetch files. Please try again later.');
      setFiles([]);
      setTotalFiles(0);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    files,
    totalFiles,
    loading,
    error,
    refreshFiles
  };
};